import { render, staticRenderFns } from "./MantenimientoCapacitacion.vue?vue&type=template&id=5f6ecbeb&scoped=true"
import script from "./MantenimientoCapacitacion.vue?vue&type=script&lang=js"
export * from "./MantenimientoCapacitacion.vue?vue&type=script&lang=js"
import style0 from "./MantenimientoCapacitacion.vue?vue&type=style&index=0&id=5f6ecbeb&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5f6ecbeb",
  null
  
)

export default component.exports